<div class="container">
  <!-- section title -->
  <h2 class="section-title wow fadeInUp">Services</h2>

  <div class="spacer-60"></div>

  <div class="row">
    <div class="col-md-4">
      <!-- service box -->
      <div class="service-box rounded data-background padding-30 text-center text-light shadow-blue bg-blue">
        <img src="assets/images/service-1.svg" alt="UI/UX design" />
        <h3 class="mb-3 mt-0">UI/UX design</h3>
        <p class="mb-0">From research, UX and UI designing using the 5 stages of UX design, i will professionally help you improve your systems. </p>
      </div>
      <div class="spacer-30 d-md-none d-lg-none"></div>
    </div>

    <div class="col-md-4">
      <!-- service box -->
      <div class="service-box rounded data-background padding-30 text-center shadow-yellow bg-yellow">
        <img src="assets/images/service-2.svg" alt="UI/UX design" />
        <h3 class="mb-3 mt-0">Web/ Mobile Development</h3>
        <p class="mb-0">I develop professional Web and Mobile applications that meet your clients' and personal needs. </p>
      </div>
      <div class="spacer-30 d-md-none d-lg-none"></div>
    </div>

  

    <div class="col-md-4">
      <!-- service box -->
      <div class="service-box rounded data-background padding-30 text-center shadow-yellow bg-yellow">
        <img src="assets/images/service-2.svg" alt="UI/UX design" />
        <h3 class="mb-3 mt-0">RPA Development</h3>
        <p class="mb-0">If you are looking to improve tedious process automation i am glad to help with that as well.I develop robots to do just that.</p>
      </div>
      <div class="spacer-30 d-md-none d-lg-none"></div>
    </div>

  <div class="mt-5 text-center">
    <p class="mb-0">Looking for a custom job? <a href="https://www.linkedin.com/in/leslie-chihwai-284515170/" (click)="scrollTo('contact')">Click here</a> to contact me! 👋</p>
  </div>
</div>
